import { arrayOf, Schema } from 'normalizr';


const AFFILIATE_TOOL_SCHEMA = new Schema('affiliateTools');

export const AFFILIATE_TOOLS_SCHEMA = {
  items: arrayOf(AFFILIATE_TOOL_SCHEMA),
};

const CUSTOM_BANNER_SCHEMA = new Schema('customBanners');

export const CUSTOM_BANNERS_SCHEMA = arrayOf(CUSTOM_BANNER_SCHEMA);
